import StudentAdminPage from './StudentAdminPage';

export default StudentAdminPage;
